var React = require('react');

function Name (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"className":"stroke","transform":"translate(-719.000000, -2404.000000)","stroke":"#F2C1B6","strokeWidth":"1.5"},React.createElement("g",{"transform":"translate(720.000000, 2224.000000)"},React.createElement("g",{"transform":"translate(0.000000, 147.000000)"},React.createElement("g",{"transform":"translate(0.000000, 34.000000)"},React.createElement("polygon",{"points":"0 49.1398926 11.7182617 -4.97379915e-14 541 0.427246094 514.214481 21 535.642896 21 514.214481 49.1398926"})))))));
}

Name.defaultProps = {"preserveAspectRatio":"none","width":"545px","height":"51px","viewBox":"0 0 545 51","version":"1.1"};

module.exports = Name;

Name.default = Name;
